import { ClimateAction } from "@/domain/climate-action/models/climate-action";

export const isTopLevelClimateAction = (climateAction: ClimateAction, climateActionList: ClimateAction[]) => {
  if (climateAction.parentId === null) {
    return true;
  }
  const parent = climateActionList.find((o) => o.id === climateAction.parentId);
  return parent === undefined;
};
